const urlPatterns: {pattern: string; key: string}[] = [
  {pattern: '/dashboard/personnel/employee/:id/:view', key: 'id'},
  {pattern: '/dashboard/personnel/employee/:id', key: 'id'},
  {pattern: '/dashboard/personnel/:id/:view', key: 'id'},
  {pattern: '/dashboard/personnel/:id', key: 'id'},
  {pattern: '/admin/personnel/employee/:id/:view', key: 'id'},
  {pattern: '/admin/personnel/employee/:id', key: 'id'},
  {pattern: '/admin/personnel/:id/:view', key: 'id'},
  {pattern: '/admin/personnel/:id', key: 'id'},
  {
    pattern: '/dashboard/vendors/personnel/:vendorId/personnel/:id/:view',
    key: 'id',
  },
  {
    pattern: '/dashboard/vendors/personnel/:vendorId/personnel/:id',
    key: 'id',
  },
  {
    pattern: '/admin/vendors/personnel/:vendorId/personnel/:id/:view',
    key: 'id',
  },
  {
    pattern: '/admin/vendors/personnel/:vendorId/personnel/:id',
    key: 'id',
  },
  {pattern: '/dashboard/vendor/:vendorId/personnel/:id/:view', key: 'id'},
  {pattern: '/admin/vendor/:vendorId/personnel/:id/:view', key: 'id'},
];

/**
 * @registry Extracts a personnel ID from a badge-scan URL by matching known route patterns.
 */
export function extractPersonnelIdFromBadge(url: string): number | null {
  let path = url;

  if (path.includes(window.location.hostname)) {
    path = path.split(window.location.hostname)[1];
  }

  for (const {pattern, key} of urlPatterns) {
    const regexPattern = pattern.replace(/:[^\s/]+/g, '([^/]+)');
    const regex = new RegExp(`^${regexPattern}$`);
    const match = path.match(regex);

    if (match) {
      const keys = pattern
        .split('/')
        .filter(segment => segment.startsWith(':'));
      const keyIndex = keys.indexOf(`:${key}`) + 1;
      const parsed = parseInt(match[keyIndex], 10);
      return isNaN(parsed) ? null : parsed;
    }
  }

  return null;
}
